import { useContext } from "react";
import { UncancelActionContext } from "./UncancelActionContext";

function usePrepareCancel() {
  const { setElementId, setShowModal } = useContext(UncancelActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareCancel;
